export function checkWebView(): boolean {
  return /traveler/i.exec(navigator.userAgent) ? true : false;
}
